// eslint-disable-next-line max-classes-per-file
import type {
  DataFestivalInterface,
  DataFestivalToursInterface,
  DataHolidayInterface,
  DataHolidayToursInterface,
  DataHotDealToursInterface,
  DayInterface,
  HolidayInterface,
  PeriodInterface,
  ResponseFestivalToursInterface,
  ResponseHolidayToursInterface,
  ResponseHotDealToursInterface,
  ResponseSearchToursInterface,
  TourInterface,
} from "@/app/[lang]/tour-packages/responseTourInterface";

export interface RequestSearchTourInterface {
  destinationId?: number;
  citySlug?: string;
  countrySlug?: string;
  startDate?: string;
  endDate?: string;
}

export class SearchToursPeriodsInterface {
  travelFromDate: string;

  travelToDate: string;

  bookingFromDate: string;

  bookingToDate: string;

  singlePrice: number;

  twinPrice: number;

  triplePrice: number;

  childPrice: number;

  childExtraPrice: number;

  currencyCode: string;

  constructor(res: any) {
    this.travelFromDate = res?.travelFromDate || "";
    this.travelToDate = res?.travelToDate || "";
    this.bookingFromDate = res?.bookingFromDate || "";
    this.bookingToDate = res?.bookingToDate || "";
    this.singlePrice = res?.singlePrice || 0;
    this.twinPrice = res?.twinPrice || 0;
    this.triplePrice = res?.triplePrice || 0;
    this.childPrice = res?.childPrice || 0;
    this.childExtraPrice = res?.childExtraPrice || 0;
    this.currencyCode = res?.currencyCode || "";
  }
}

export class SearchToursAirlineInterface {
  name: string;

  code: string;

  slug: string;

  logo: string;

  constructor(res: any) {
    this.name = res.name;
    this.code = res.code;
    this.slug = res.slug;
    this.logo = res.logo;
  }
}

export class SearchTourDestinationInterface {
  cityId: number;

  cityName: string;

  countryId: number;

  countryName: string;

  id: number;

  citySlug: string;

  countrySlug: string;

  constructor(res: any) {
    this.cityId = res?.cityId || 0;
    this.cityName = res?.cityName || "";
    this.countryId = res?.countryId || 0;
    this.countryName = res?.countryName || "";
    this.id = res?.id || 0;
    this.citySlug = res?.citySlug || 0;
    this.countrySlug = res?.countrySlug || 0;
  }
}

interface Inspiration {
  id: number;
  name: string;
  slug: string;
}

interface DataSearchToursInspirations {
  [key: string]: Inspiration;
}

export interface RequestHolidayToursInterface {
  holidayNum?: number;
  tourNumPerHoliday?: number;
}
export interface RequestFestivalToursInterface {
  limitNumber?: number;
}

export class DayClass {
  id: number;

  name: string;

  slug: string;

  constructor(res: DayInterface) {
    this.id = Number(res?.id) || 0;
    this.name = res?.name || "";
    this.slug = res?.slug || "";
  }
}

export class AirlineClass {
  name: string;

  code: string;

  slug: string;

  logo: string;

  constructor(res: any) {
    this.name = res?.name;
    this.code = res?.code;
    this.slug = res?.slug;
    this.logo = res?.logo;
  }
}
export class DestinationClass {
  cityId: number;

  cityName: string;

  citySlug: string;

  countryId: number;

  countryName: string;

  countrySlug: string;

  id: number;

  constructor(
    cityId: number,
    cityName: string,
    citySlug: string,
    countryId: number,
    countryName: string,
    countrySlug: string,
    id: number,
  ) {
    this.cityId = cityId;
    this.cityName = cityName;
    this.citySlug = citySlug;
    this.countryId = countryId;
    this.countryName = countryName;
    this.countrySlug = countrySlug;
    this.id = id;
  }
}
export class ObjectTourClass {
  id: number;

  name: string;

  slug: string;

  inspirationType: string;

  constructor(res: any) {
    this.id = res?.id || 0;
    this.name = res?.name || "";
    this.slug = res?.slug || "";
    this.inspirationType = res?.inspirationType || "";
  }
}

export class GreenCertificationsClass {
  id: number;

  name: string;

  slug: string;

  constructor(res: any) {
    this.id = res?.id || 0;
    this.name = res?.name || "";
    this.slug = res?.slug || "";
  }
}

export class TourDiscountClass {
  roomType: string;

  discountType: string;

  amount: number;

  constructor(res: any) {
    this.roomType = res?.roomType || "";
    this.discountType = res?.discountType || "";
    this.amount = res?.amount || 0;
  }
}
export class HolidayClass {
  id: number = 0;

  name: string = "";

  slug: string = "";

  constructor(res: any) {
    this.id = res?.id || this.id;
    this.name = res?.name || this.name;
    this.slug = res?.slug || this.slug;
  }
}
export class PeriodClass {
  travelFromDate: string;

  travelToDate: string;

  bookingFromDate: string;

  bookingToDate: string;

  singlePrice: number;

  twinPrice: number;

  triplePrice: number;

  childPrice: number;

  childExtraPrice: number;

  currencyCode: string;

  id: number;

  isLastMinute: boolean;

  constructor(res: PeriodInterface) {
    this.travelFromDate = res.travelFromDate || "";
    this.travelToDate = res.travelToDate || "";
    this.bookingFromDate = res.bookingFromDate || "";
    this.bookingToDate = res.bookingToDate || "";
    this.singlePrice = res.singlePrice || 0;
    this.twinPrice = res.twinPrice || 0;
    this.triplePrice = res.triplePrice || 0;
    this.childPrice = res.childPrice || 0;
    this.childExtraPrice = res.childExtraPrice || 0;
    this.currencyCode = res.currencyCode || "";
    this.id = res.id || 0;
    this.isLastMinute = res.isLastMinute || false;
  }
}
export class TourClass {
  tourId: number;

  slug: string;

  code: string;

  name: string;

  isRecommend: boolean;

  hotelStarRating: number;

  eat: string;

  highlight: string;

  shopping: string;

  periods: PeriodClass[];

  airline: AirlineClass;

  destinations: DestinationClass[];

  isFavourite: boolean;

  photos: string[];

  festivals: ObjectTourClass[];

  inspirations: ObjectTourClass[];

  lowestPrice: {
    price: number;
    originalPrice: number;
    periodId: number;
    type: string;
    currencyCode: string;
    discount: {
      roomType: string;
      discountType: string;
      amount: number;
    };
  };

  startPeriod: string;

  endPeriod: string;

  tourRange: {
    days: number;
    nights: number;
  };

  tourDiscount?: TourDiscountClass;

  greenCertifications: GreenCertificationsClass[];

  isGreenCertificate: boolean;

  isLastMinute: boolean;

  holidays: HolidayInterface[];

  score?: number = 0;

  countryRanking?: number = 0;

  constructor(res: TourInterface) {
    this.tourId = res?.tourId || 0;
    this.slug = res?.slug || "";
    this.code = res?.code || "";
    this.name = res?.name || "";
    this.isRecommend = res?.isRecommend || false;
    this.hotelStarRating = res?.hotelStarRating || 0;

    this.eat = res?.eat || "";
    this.highlight = res?.highlight || "";
    this.shopping = res?.shopping || "";
    this.periods =
      res?.periods?.map((val: PeriodClass) => new PeriodClass(val)) || [];
    this.airline = new AirlineClass(res?.airline) || new AirlineClass({});
    this.destinations =
      res?.destinations?.map(
        (val: DestinationClass) =>
          new DestinationClass(
            val.cityId,
            val.cityName,
            val.citySlug,
            val.countryId,
            val.countryName,
            val.countrySlug,
            val.id,
          ),
      ) || [];
    this.isFavourite = res?.isFavourite || false;
    this.photos = res?.photos || [];
    this.festivals =
      (res?.festivals || []).map((val) => new ObjectTourClass(val)) || [];
    this.inspirations =
      (res?.inspirations || []).map((val) => new ObjectTourClass(val)) || [];
    this.lowestPrice = {
      price: res?.lowestPrice?.price || 0,
      originalPrice: res?.lowestPrice?.originalPrice || 0,
      periodId: res?.lowestPrice?.periodId || 0,
      type: res?.lowestPrice?.type || "",
      currencyCode: res?.lowestPrice?.currencyCode || "",
      discount: {
        roomType: res?.lowestPrice?.discount?.roomType || "",
        discountType: res?.lowestPrice?.discount?.discountType || "",
        amount: res?.lowestPrice?.discount?.amount || 0,
      },
    };
    this.startPeriod = res?.startPeriod || "";
    this.endPeriod = res?.endPeriod || "";
    this.tourRange = {
      days: res?.tourRange.days,
      nights: res?.tourRange.nights,
    };
    this.tourDiscount =
      new TourDiscountClass(res?.tourDiscount) || new TourDiscountClass({});
    this.greenCertifications = (res?.greenCertifications || []).map(
      (val: GreenCertificationsClass) => new GreenCertificationsClass(val),
    ) || [new GreenCertificationsClass({})];
    this.isGreenCertificate = res?.isGreenCertificate || false;
    this.isLastMinute = res.periods.some((period) => period.isLastMinute);
    this.holidays = (res?.holidays || []).map(
      (holiday) => new HolidayClass(holiday),
    );
  }
}
export class DataHolidayClass {
  id: number;

  name: string;

  slug: string;

  tours: TourClass[];

  constructor(res: DataHolidayInterface) {
    this.id = Number(res?.id) || 0;
    this.name = res?.name || "";
    this.slug = res?.slug || "";
    this.tours = res?.tours?.map((val) => new TourClass(val)) || [];
  }
}
export class DataHolidayToursClass {
  holiday: DataHolidayClass[];

  day: DayClass[];

  constructor(res: DataHolidayToursInterface) {
    this.day = res?.day?.map((val: DayClass) => new DayClass(val)) || [];
    this.holiday = res?.holiday?.map((val) => new DataHolidayClass(val)) || [];
  }
}

export class ResponseHolidayTours {
  status: boolean;

  message: string;

  data: DataHolidayToursClass;

  constructor(res: ResponseHolidayToursInterface) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.data = new DataHolidayToursClass(res?.data) || {};
  }
}

export class DataFestivalClass {
  id: number;

  name: string;

  slug: string;

  festival_date: string;

  constructor(res: DataFestivalInterface) {
    this.id = Number(res?.id) || 0;
    this.name = res?.name || "";
    this.slug = res?.slug || "";
    this.festival_date = res?.festival_date || "";
  }
}
export class DataFestivalToursClass {
  festivals: DataFestivalClass[];

  tours: TourClass[];

  constructor(res: DataFestivalToursInterface) {
    this.tours = res?.tours?.map((val) => new TourClass(val)) || [];
    this.festivals =
      res?.festivals?.map(
        (val: DataFestivalClass) => new DataFestivalClass(val),
      ) || [];
  }
}
export class ResponseFestivalTours {
  status: boolean;

  message: string;

  data: DataFestivalToursClass;

  constructor(res: ResponseFestivalToursInterface) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.data = new DataFestivalToursClass(res?.data) || {};
  }
}

export class DataHotDealToursClass {
  lastMinute: TourClass[];

  specialDiscount: TourClass[];

  constructor(res: DataHotDealToursInterface) {
    this.lastMinute = res?.lastMinute?.map((val) => new TourClass(val)) || [];
    this.specialDiscount =
      res?.specialDiscount?.map((val) => new TourClass(val)) || [];
  }
}

export class ResponseHotDealsTours {
  status: boolean;

  message: string;

  data: DataHotDealToursClass;

  constructor(res: ResponseHotDealToursInterface) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.data = new DataHotDealToursClass(res?.data) || {};
  }
}
export class ResponseSearchTours {
  status: boolean;

  message: string;

  data: {
    tours: TourClass[];
    countryId: number;
    countryName: string;
    countrySlug: string;
    cityId: number;
    cityName: string;
    citySlug: string;
  };

  constructor(res?: ResponseSearchToursInterface) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.data = {
      tours: res?.data?.tours?.map((d) => new TourClass(d)) || [],
      countryId: res?.data?.countryId || 0,
      countryName: res?.data?.countryName || "",
      countrySlug: res?.data?.countrySlug || "",
      cityId: res?.data?.cityId || 0,
      cityName: res?.data?.cityName || "",
      citySlug: res?.data?.citySlug || "",
    };
  }
}

export interface TourFilterLabelInterface {
  value: string;
  slug: string;
  display: string;
  image?: string;
}

export interface CountryRankingScoreInterface {
  id: number;

  slug: string;

  score: number;
}
export class CountryRankingScoreClass {
  id: number | null = null;

  slug: string = "";

  score: number = 0;

  constructor(data: CountryRankingScoreInterface) {
    this.id = data.id ?? this.id;
    this.slug = data.slug ?? this.slug;
    this.score = data.score ?? this.score;
  }
}
